var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_2959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19.5879V8.88352L22.4513 9.83603C22.913 10.1391 23.533 10.0104 23.836 9.54869C24.139 9.08697 24.0104 8.46701 23.5487 8.16398L19 5.17862V3C19 2.44772 18.5523 2 18 2C17.4477 2 17 2.44772 17 3V3.866L13.2697 1.4178C12.497 0.860534 11.462 0.860734 10.6894 1.4184L0.449805 8.16496C-0.0113768 8.46882 -0.138912 9.089 0.164946 9.55018C0.468804 10.0114 1.08899 10.1389 1.55017 9.83504L2.99999 8.87981V19.5879C2.99999 20.9246 4.06999 22 5.39999 22H18.6C19.93 22 21 20.9246 21 19.5879ZM7.99999 8C7.99999 7.44772 8.4477 7 8.99999 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H8.99999C8.4477 9 7.99999 8.55228 7.99999 8ZM9.99999 13V21H7.99999V12.8C7.99999 11.8077 8.80771 11 9.79999 11H14.2C15.1923 11 16 11.8077 16 12.8V21H14V13H9.99999Z",
    fill: "#212D4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_2959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconBlack);
export default __webpack_public_path__ + "static/media/home-icon-black.bebb663e7b4d133a9f8d1ec43b25dcd2.svg";
export { ForwardRef as ReactComponent };